import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=d190e940&"
import script from "./Post.vue?vue&type=script&lang=js&"
export * from "./Post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d190e940')) {
      api.createRecord('d190e940', component.options)
    } else {
      api.reload('d190e940', component.options)
    }
    module.hot.accept("./Post.vue?vue&type=template&id=d190e940&", function () {
      api.rerender('d190e940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/post/Post.vue"
export default component.exports